import { Injectable } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { ServiceBase } from './servicebase.service';

@Injectable({
  providedIn: 'root'
})
export class LeCaseNumberService extends ServiceBase {
  public getLECaseNumberByAgency(agencyId: string): Observable<ServerModels.ENESS_XREF_LECaseNumbers[]> {
    let options = {
      headers: this.httpNoCache.headers,
      params: { 'agencyID': agencyId }
    };
    return this.http.get<ServerModels.ENESS_XREF_LECaseNumbers[]>(`${this.apiRoot}/api/LECaseNumber/GetLECaseNumbersByAgency?`, options)
      .pipe(catchError(this.swallowError<any>('getLECaseNumberByAgency', 'defaultMsg', null, null))); 
  }
  public filterCaseNumbers(query:string, caseNumbers: any[], itemToIgnore: any[]): any[] {
    let filtered: any[] = [];
    for (let i = 0; i < caseNumbers.length; i++) {
      let caseNumber = caseNumbers[i];

      if (caseNumber.LECaseNumber.toLowerCase().indexOf(query.toLowerCase()) == 0 && itemToIgnore.find(x => x.LECaseNumberID == caseNumber.LECaseNumberID) == null ) {
        filtered.push(caseNumber);
      }
    }
    return filtered;
  }
}
